// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Weekly schedule container */
.weekly-schedule {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-top: 20px;
}

/* Individual day cell */
.weekly-schedule .day {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  /* background-color: #f9f9f9;
  color: 'black'; */
  font-size: 14px;
  font-weight: bold;
}

/* Timeslot text */
.weekly-schedule .timeslot {
  margin-top: 5px;
  font-size: 12px;
  color: #aaf;
}

@media (max-width: 800px) {
  .weekly-schedule {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .weekly-schedule .day {
    font-size: 16px;
    padding: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/SweatTextDashboard.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB;mBACiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":["/* Weekly schedule container */\n.weekly-schedule {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 10px;\n  margin-top: 20px;\n}\n\n/* Individual day cell */\n.weekly-schedule .day {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 10px;\n  text-align: center;\n  /* background-color: #f9f9f9;\n  color: 'black'; */\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* Timeslot text */\n.weekly-schedule .timeslot {\n  margin-top: 5px;\n  font-size: 12px;\n  color: #aaf;\n}\n\n@media (max-width: 800px) {\n  .weekly-schedule {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n  .weekly-schedule .day {\n    font-size: 16px;\n    padding: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
